import { React, forwardRef, useState, useRef, useImperativeHandle, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Model/Share/Network/FetchModule';

import SelectOnPath from '../../image/SelectOn.png';
import SelectOffPath from '../../image/SelectOff.png';
import CheckImage from '../../image/CheckImage.png';

const CoachSelectBox = forwardRef((props, ref) => {
  const history = useHistory();

	const [isClicked, setIsClicked] = useState(false);
  const [options, setOptions] = useState([]);
	const [teacherId, setTeacherId] = useState(-1);
	const [defaultVal, setDefaultVal] = useState([]);

  const TopLevelRef = useRef();
	const SelectRef = useRef();

	useImperativeHandle(ref, () => ({
		getValue: (val) => {
			return defaultVal;
		},
		setValue: (val) => {
			setTeacherId(val);
		},
		setIsClicked: () => {	
			if (isClicked) {
        SelectRef.current.style.border = '0px';
        SelectRef.current.style.height = `0px`;
        SelectRef.current.style.overflow = 'hidden';
				setIsClicked(false);
			}
		}
	}))

  useEffect(() => {
    setOptions([]);
    (
      async () => {
        const fetchModule = new FetchModule();
        const data = await fetchModule.getData('coach/select/', 'GET');
				
        if (data.status === 200) setOptions(data.data);
        else if (data.status === 401) history.push('/');
        else {};
      }
    )();
  }, [history])

	useEffect(() => {
		if (options.length === 0 || teacherId === -1) return;
    
    var teacherIdList = teacherId.split(',');

    var newDefaultVal = [];

    for (var i = 0; i < teacherIdList.length; i++) {
      newDefaultVal.push(options[options.findIndex(j => j.id === parseInt(teacherIdList[i]))])
    }

    setDefaultVal(newDefaultVal);
	}, [options, teacherId])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
      SelectRef.current.style.border = '0px';
      SelectRef.current.style.height = `0px`;
      SelectRef.current.style.overflow = 'hidden';
      setIsClicked(false);
    }
  }

	function onClick() {
		if (isClicked) {
			SelectRef.current.style.border = '0px';
			SelectRef.current.style.height = `0px`;
			SelectRef.current.style.overflow = 'hidden';
			setIsClicked(false);
		}
		else {
			SelectRef.current.style.border = '1px solid #FF8B48';
			SelectRef.current.style.height = (32 * (options.length + 1 )) > 130 ? `130px` : ((32 * (options.length + 1)) + 'px');
			SelectRef.current.style.overflowY = 'scroll';
			SelectRef.current.style.overflowX = 'none';
			setIsClicked(true);
		}
	}

  // 코치 클릭시
	function optionalClick(index) {
    // 입력시 중복확인 => 존재하면 삭제, 존재하지 않으면 추가
    var newDefaultVal = defaultVal.slice();

    if (newDefaultVal.includes(options[index])) {
      var deletedIndex = 0;

      newDefaultVal.filter(function(item, idx) {
        // 두개가 같으면
        if (options[index] === item) {
          deletedIndex = idx;
          return;
        }
      })

      newDefaultVal.splice(deletedIndex, 1);
      setDefaultVal(newDefaultVal);
    }
    else {
      newDefaultVal.push(options[index]);
      setDefaultVal(newDefaultVal);
      setTeacherId(-1);
    }
	}

	return (
    <TopLevelWrapper ref={TopLevelRef}>
      <DefaultView 
        isClicked={isClicked}
        onClick={onClick}>
        <OptionWrapper>
          <ColorBoxWrapper>
            {
              defaultVal.map((data, index) => (
                <ColorMapper>
                  { index < 3 && <ColorBox>{index === 0 || index === 1 ? data.name : `+` + (defaultVal.length - 2)}</ColorBox> }
                </ColorMapper>
              ))
            }
          </ColorBoxWrapper>
        </OptionWrapper>
        <ArrowImage src={SelectOffPath} isClicked={isClicked}/>
      </DefaultView>
      <SelectBox
        ref={SelectRef}
        isClicked={isClicked}>
        {
          options.map((data, index) =>
            <OptionWrapper key={index} onClick={() => optionalClick(index)}>
              <Option isClicked={defaultVal.includes(data)}>{data.name}</Option>
              { defaultVal.includes(data) && <Check src={CheckImage}/> }
            </OptionWrapper>
          )
        }
      </SelectBox>
    </TopLevelWrapper>
  )
})

export default CoachSelectBox;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;
	
	width: 344px;
	height: 32px;

	margin-top: 8px;
`;

const DefaultView = styled.div`
  display: flex;
	flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0 8px 0 8px;

	width: 328px;
	height: 32px;
  
  z-index: 3;

	border: 1px solid #CBCBCB;
	border-radius: 8px;

	background-color: rgba(255, 255, 255, 1);
  
  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const ArrowImage = styled.img`
  width: 24px;
  height: 24px;

  transition: all 0.3s ease-in-out;

  transform: ${props => props.isClicked ? `rotateZ(-180deg)` : `rotateZ(0deg)`};

  :hover {
    cursor: pointer;
  }
`;

const Check = styled.img`
  width: 12px;
  height: 9px;
`;

const SelectBox = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;

	justify-content: flex-start;
	align-items: flex-start;

  margin-top: 40px;

	width: 328px;
	height: 0px;

  padding: 0 8px 0 8px;

  z-index: 2;

  border: 0px;
	border-radius: 8px;
	overflow: hidden;

	background-color: rgba(255, 255, 255, 1);

  transition: all 0.3s ease-in-out;

	:hover {
		cursor: pointer;
	}

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #FF8B48;
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const OptionWrapper = styled.div`
	display: flex;
	flex-direction: row;
  
  justify-content: space-between;
  align-items: center;

	width: 100%;

	:hover {
		cursor: pointer;
	}
`;

const Option = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

  color: ${props => props.isClicked ? `#FF8B48` : `#555555`};

  margin: 6px 0 6px 0;
  padding: 0 0 0 0;
`;

const ColorBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const ColorMapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const ColorBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0 8px 0 8px;

  height: 24px;

  border-radius: 6px;
  background-color: #FF8B48;

	font-family: NotoSansKR-Regular;
	font-size: 14px;

  color: #FFFFFF;
`;